module.exports = __webpack_public_path__ + "static/img/bg_blur05.cf677a20.jpg";